// client/src/modules/quoting/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for Quoting module sidebar
 * Connected Data provides access to reference data tables (Customers, Equipment, Price Book)
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/quoting' },
  {
    label: 'Quotes',
    path: '/quoting/quotes',
    children: [
      { label: 'All Quotes', path: '/quoting/quotes' },
      { label: 'Follow-Up Queue', path: '/quoting/follow-up-queue' },
      { label: 'Templates', path: '/quoting/templates' },
    ],
  },
  { label: 'Analytics', path: '/quoting/analytics' },
  {
    label: 'Connected Data',
    path: '/quoting/customers',
    children: [
      { label: 'Customers', path: '/quoting/customers' },
      { label: 'Equipment', path: '/quoting/equipment' },
      { label: 'Price Book', path: '/quoting/price-book' },
      { label: 'Rate Sheet', path: '/quoting/rate-sheet' },
      // Quote terms are edited in CRM settings. Linking to them from Quoting
      // (where they are actually used) saves hunting through Sales settings.
      { label: 'Terms & Conditions', path: '/crm/settings?tab=terms-and-conditions' },
    ],
  },
];

/**
 * The bar while the quote worksheet is on for the viewer (#6274 Q9; ModuleContext picks it). New Quote (a button) opens
 * the worksheet; Pricing and Templates are the price sheet and the customer quote wording every worksheet quote reads;
 * Price Catalog joins Connected Data. The old quote templates leave the bar (they start old-screen quotes; the page
 * stays until Q10 removes it). Everything else is today's bar, so older quotes stay reachable.
 */
export const worksheetNavItems: NavItem[] = [
  { label: 'Dashboard', path: '/quoting' },
  { label: 'New Quote', path: '/quoting/quotes/create', cta: true },
  {
    label: 'Quotes',
    path: '/quoting/quotes',
    children: [
      { label: 'All Quotes', path: '/quoting/quotes' },
      { label: 'Follow-Up Queue', path: '/quoting/follow-up-queue' },
    ],
  },
  { label: 'Analytics', path: '/quoting/analytics' },
  { label: 'Pricing', path: '/quoting/pricing' },
  { label: 'Templates', path: '/quoting/customer-quote' },
  {
    label: 'Connected Data',
    path: '/quoting/customers',
    children: [
      { label: 'Customers', path: '/quoting/customers' },
      { label: 'Equipment', path: '/quoting/equipment' },
      { label: 'Price Book', path: '/quoting/price-book' },
      { label: 'Price Catalog', path: '/quoting/price-catalog' },
      { label: 'Rate Sheet', path: '/quoting/rate-sheet' },
      { label: 'Terms & Conditions', path: '/crm/settings?tab=terms-and-conditions' },
    ],
  },
];
